import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { makecartempty } from '../../redux/reducers/cartSlice';
import 'react-toastify/dist/ReactToastify.css';
import styles from '../../styles/placeorder.module.css';

function PlaceOrder() {
  const { cart, address_details } = useSelector((state) => state.cart);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const itemsPrice = cart.reduce((acc, item) => acc + item.quantity * item.price, 0);
  const shipping = itemsPrice >= 500 ? 0 : 200;
  const totalPrice = itemsPrice + shipping;

  const placeOrder = async () => {
    try {
      setLoading(true);
      
      const orderData = {
        orderItems: cart,
        shippingAddress: {
          address: address_details.address,
          country: address_details.country,
          city: address_details.city,
          postalCode: address_details.postalCode
        },
        paymentMethod: 'paypal',
        itemsPrice: itemsPrice,
        mobileNumber: address_details.mobileNumber,
        shippingPrice: shipping,
        totalPrice: totalPrice
      };

      const res = await axios.post('https://pro-shop-backend.vercel.app/api/orders', orderData);

      if (res.data.success === true) {
        toast.success(res.data.message || 'Order placed successfully!', {
          position: 'bottom-right',
          theme: 'colored'
        });
        dispatch(makecartempty());
        navigate(`/order/${res.data.message._id}`);
      } else {
        toast.error(res.data.message || 'Failed to place order', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  if (cart.length === 0) {
    return (
      <div className={styles.placeOrderContainer}>
        <Navbar />
        <div className={styles.emptyCartContainer}>
          <div className={styles.emptyCartContent}>
            <div className={styles.emptyIcon}>🛒</div>
            <h2 className={styles.emptyTitle}>Your cart is empty</h2>
            <p className={styles.emptyText}>
              Looks like you haven't added any items to your cart yet.
              <br />
              Browse our products and start shopping!
            </p>
            <button
              type="button"
              className={styles.shopButton}
              onClick={() => navigate('/')}
            >
              Continue Shopping
            </button>
          </div>
        </div>
        <ToastContainer
          position="bottom-right"
          theme="colored"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }

  return (
    <div className={styles.placeOrderContainer}>
      <Navbar />

      <div className={styles.placeOrderWrapper}>
        <div className={styles.pageHeader}>
          <h3 className={styles.pageTitle}>Place Order</h3>
          <p className={styles.pageSubtitle}>Review your order before placing</p>
        </div>

        <div className={styles.placeOrderGrid}>
          <div className={styles.orderDetails}>
            <div className={styles.detailSection}>
              <h4 className={styles.sectionTitle}>Shipping Details</h4>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Address:</span>
                <span>
                  {address_details.address}, {address_details.city}, {address_details.postalCode}, {address_details.country}
                </span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>Contact:</span>
                <span>{address_details.mobileNumber}</span>
              </div>
            </div>

            <div className={styles.detailSection}>
              <h4 className={styles.sectionTitle}>Order Items ({cart.length})</h4>
              {cart.map((elem, i) => (
                <div key={i} className={styles.orderItem}>
                  <img src={elem.image} alt={elem.name} className={styles.orderItemImage} />
                  <div className={styles.orderItemDetails}>
                    <span className={styles.orderItemName}>{elem.name}</span>
                    <span className={styles.orderItemMeta}>
                      {elem.quantity} × ${elem.price}
                    </span>
                  </div>
                  <span className={styles.orderItemTotal}>
                    ${(elem.quantity * elem.price)}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.orderSummary}>
            <h4 className={styles.summaryTitle}>Order Summary</h4>

            <div className={styles.summaryRow}>
              <span>Items ({cart.reduce((acc, item) => acc + item.quantity, 0)})</span>
              <span>${itemsPrice}</span>
            </div>

            <div className={styles.summaryRow}>
              <span>Shipping</span>
              <span>{shipping === 0 ? 'Free' : `$${shipping}`}</span>
            </div>

            {shipping === 0 && itemsPrice >= 500 && (
              <div className={styles.freeShippingBadge}>
                🎉 Free Shipping Applied!
              </div>
            )}

            <div className={`${styles.summaryRow} ${styles.summaryTotal}`}>
              <span>Total</span>
              <span>${totalPrice}</span>
            </div>

            <button
              type="button"
              className={styles.placeOrderBtn}
              disabled={loading}
              onClick={placeOrder}
            >
              {loading ? (
                <>
                  <span className={styles.loader}></span>
                  Placing Order...
                </>
              ) : (
                'Place Order'
              )}
            </button>

            <button
              type="button"
              className={styles.backBtn}
              onClick={() => navigate('/shipping')}
            >
              ← Back to Shipping
            </button>
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default PlaceOrder;